import { render, staticRenderFns } from "./switchPanel.vue?vue&type=template&id=5d1050a3&"
import script from "./switchPanel.vue?vue&type=script&lang=js&"
export * from "./switchPanel.vue?vue&type=script&lang=js&"
import style0 from "./switchPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports